module.exports = __webpack_public_path__ + "static/media/plantH.4a7c69b1.png";